import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e3431c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  "element-loading-background": "rgba(0, 0, 0, 0.5)",
  style: {"padding-top":"0px"}
}
const _hoisted_2 = { style: {"float":"left"} }
const _hoisted_3 = { style: {"margin-left":"20px"} }
const _hoisted_4 = { style: {"float":"right"} }
const _hoisted_5 = {
  key: 0,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_6 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_7 = {
  key: 0,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_8 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_9 = {
  key: 0,
  style: {"width":"100% !important","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_10 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_11 = {
  key: 0,
  style: {"width":"100% !important","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_12 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_13 = { style: {"width":"100% !important","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_14 = { style: {"width":"100% !important","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { style: {"width":"100% !important","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_18 = { style: {"width":"100% !important","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_19 = { style: {"width":"100% !important","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_20 = { style: {"width":"100% !important","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_21 = { style: {"width":"100% !important","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { key: 1 }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 发票信息 ", -1))
const _hoisted_26 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { key: 2 }
const _hoisted_30 = ["title"]
const _hoisted_31 = ["title"]
const _hoisted_32 = ["title"]
const _hoisted_33 = ["title"]
const _hoisted_34 = { key: 1 }
const _hoisted_35 = ["title"]
const _hoisted_36 = ["title"]
const _hoisted_37 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { key: 1 }
const _hoisted_41 = ["title"]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both","height":"20px"} }, null, -1))
const _hoisted_43 = { style: {"clear":"both"} }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 核销信息 ", -1))
const _hoisted_45 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_46 = { style: {"width":"100% !important"} }
const _hoisted_47 = { key: 0 }
const _hoisted_48 = { key: 1 }
const _hoisted_49 = {
  key: 2,
  style: {"font-size":"13px","color":"#fe995b","font-weight":"900","margin-left":"10px"}
}
const _hoisted_50 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_51 = {
  key: 0,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_52 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_53 = ["title"]
const _hoisted_54 = ["title"]
const _hoisted_55 = ["title"]
const _hoisted_56 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_57 = { key: 0 }
const _hoisted_58 = { key: 1 }
const _hoisted_59 = ["title"]
const _hoisted_60 = ["title"]
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"float":"left"} }, "历史记录", -1))
const _hoisted_62 = { style: {"float":"right"} }
const _hoisted_63 = { key: 0 }
const _hoisted_64 = { style: {"font-size":"13px"} }
const _hoisted_65 = ["onClick"]
const _hoisted_66 = { style: {"float":"left"} }
const _hoisted_67 = { style: {"font-weight":"900"} }
const _hoisted_68 = { key: 0 }
const _hoisted_69 = {
  key: 0,
  style: {"margin-left":"3px","font-size":"10px","border":"1px solid #aaa","height":"16px","width":"16px","float":"left","text-align":"center","line-height":"16px"}
}
const _hoisted_70 = {
  key: 1,
  style: {"margin-left":"3px","font-size":"10px","border":"1px solid #aaa","height":"16px","width":"16px","float":"left","text-align":"center","line-height":"16px"}
}
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1))
const _hoisted_72 = {
  key: 0,
  style: {"line-height":"28px"}
}
const _hoisted_73 = {
  key: 0,
  style: {"clear":"both"}
}
const _hoisted_74 = {
  key: 0,
  style: {"float":"left","text-indent":"20px"}
}
const _hoisted_75 = {
  key: 1,
  style: {"float":"left"}
}
const _hoisted_76 = {
  key: 0,
  style: {}
}
const _hoisted_77 = { key: 0 }
const _hoisted_78 = {
  key: 0,
  style: {"float":"left","text-indent":"20px"}
}
const _hoisted_79 = { style: {"font-weight":"900"} }
const _hoisted_80 = {
  key: 1,
  style: {"float":"left","text-indent":"20px"}
}
const _hoisted_81 = { style: {"font-weight":"900"} }
const _hoisted_82 = {
  key: 2,
  style: {"float":"left","text-indent":"20px"}
}
const _hoisted_83 = { style: {"font-weight":"900"} }
const _hoisted_84 = {
  key: 3,
  style: {"float":"left","text-indent":"20px"}
}
const _hoisted_85 = { style: {} }
const _hoisted_86 = ["onClick"]
const _hoisted_87 = ["onClick"]
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1))
const _hoisted_89 = { key: 1 }
const _hoisted_90 = { key: 0 }
const _hoisted_91 = { key: 1 }
const _hoisted_92 = {
  key: 0,
  style: {"text-indent":"20px","float":"left"}
}
const _hoisted_93 = { style: {"font-weight":"900"} }
const _hoisted_94 = {
  key: 1,
  style: {"text-indent":"20px","float":"left"}
}
const _hoisted_95 = { style: {"font-weight":"900"} }
const _hoisted_96 = {
  key: 2,
  style: {"text-indent":"20px","float":"left"}
}
const _hoisted_97 = { style: {"font-weight":"900"} }
const _hoisted_98 = {
  key: 3,
  style: {"text-indent":"20px","float":"left"}
}
const _hoisted_99 = { style: {} }
const _hoisted_100 = ["onClick"]
const _hoisted_101 = ["onClick"]
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1))
const _hoisted_103 = { key: 1 }
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1))
const _hoisted_105 = {
  key: 1,
  style: {"clear":"both"}
}
const _hoisted_106 = { key: 0 }
const _hoisted_107 = {
  key: 0,
  style: {"text-indent":"20px"}
}
const _hoisted_108 = { style: {"font-weight":"900"} }
const _hoisted_109 = {
  key: 1,
  style: {"text-indent":"20px"}
}
const _hoisted_110 = { style: {"font-weight":"900"} }
const _hoisted_111 = {
  key: 2,
  style: {"text-indent":"20px"}
}
const _hoisted_112 = { style: {"font-weight":"900"} }
const _hoisted_113 = {
  key: 3,
  style: {"text-indent":"20px"}
}
const _hoisted_114 = { style: {} }
const _hoisted_115 = { key: 1 }
const _hoisted_116 = {
  key: 0,
  style: {"float":"left","text-indent":"20px"}
}
const _hoisted_117 = {
  key: 1,
  style: {"float":"left","text-indent":"20px"}
}
const _hoisted_118 = { style: {"float":"left","text-indent":"20px"} }
const _hoisted_119 = {
  key: 0,
  style: {"text-indent":"20px"}
}
const _hoisted_120 = { style: {"font-weight":"900"} }
const _hoisted_121 = {
  key: 1,
  style: {"text-indent":"20px"}
}
const _hoisted_122 = { style: {"font-weight":"900"} }
const _hoisted_123 = {
  key: 2,
  style: {"text-indent":"20px"}
}
const _hoisted_124 = { style: {"font-weight":"900"} }
const _hoisted_125 = {
  key: 3,
  style: {"text-indent":"20px"}
}
const _hoisted_126 = { style: {} }
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1))
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1))
const _hoisted_129 = {
  key: 1,
  style: {"height":"40px","line-height":"40px","text-align":"center","font-size":"14px","color":"#999"}
}
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both","height":"90px"} }, null, -1))
const _hoisted_131 = { style: {"clear":"both"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_miezz_menu_tab = _resolveComponent("miezz-menu-tab")!
  const _component_ArrowDownBold = _resolveComponent("ArrowDownBold")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_ArrowUpBold = _resolveComponent("ArrowUpBold")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_CloseBold = _resolveComponent("CloseBold")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_Document = _resolveComponent("Document")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_miezz_button_bar = _resolveComponent("miezz-button-bar")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_Minus = _resolveComponent("Minus")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
      _createVNode(_component_miezz_menu_tab, {
        modelValue: _ctx.menuTab,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.menuTab) = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_card, null, {
        header: _withCtx(() => [
          _createElementVNode("div", {
            style: {"width":"100% !important","cursor":"pointer","height":"50px","line-height":"50px"},
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isCollection = !_ctx.isCollection))
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createTextVNode("应收账单"),
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.dto.Collection), 1)
            ]),
            _createElementVNode("div", _hoisted_4, [
              (_ctx.isCollection==false)
                ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ArrowDownBold)
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_el_icon, { key: 1 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ArrowUpBold)
                    ]),
                    _: 1
                  }))
            ])
          ])
        ]),
        default: _withCtx(() => [
          (_ctx.isCollection==false)
            ? (_openBlock(), _createBlock(_component_el_table, {
                key: 0,
                "row-class-name": _ctx.tableRowClassName,
                data: _ctx.dto.Collections,
                ref: "collectionBillTable",
                style: {"width":"100%","margin-top":"15px"},
                "header-cell-style": { 'text-align': 'left' },
                "cell-style": { 'text-align': 'left' },
                border: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    prop: "scope.row.Pool",
                    label: "Booking No",
                    width: "150px",
                    "show-overflow-tooltip": true
                  }, {
                    default: _withCtx((scope) => [
                      (scope.row.Pool)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.isString(scope.row.Pool.BookingNo,scope.row)), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_6, " 暂无数据 "))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "scope.row.ClientCompany",
                    label: "对账对象",
                    width: "150px",
                    "show-overflow-tooltip": true
                  }, {
                    default: _withCtx((scope) => [
                      (scope.row.ClientCompany)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.isString(scope.row.ClientCompany.NameZh,scope.row)), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_8, " 暂无数据 "))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "scope.row.CostId",
                    label: "费用名称",
                    width: "150px",
                    "show-overflow-tooltip": true
                  }, {
                    default: _withCtx((scope) => [
                      (scope.row.Cost!=undefined)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.isString(scope.row.Cost.NameZh,scope.row)), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_10, " 暂无数据 "))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "scope.row.CurrencySystem",
                    label: "币制",
                    width: "60px",
                    "show-overflow-tooltip": true
                  }, {
                    default: _withCtx((scope) => [
                      (scope.row.CurrencySystem!=undefined)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.isString(scope.row.CurrencySystem.Code,scope.row)), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_12, " 暂无数据 "))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "scope.row.UnitPrice",
                    label: "单价",
                    width: "100px",
                    "show-overflow-tooltip": true
                  }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.isString(scope.row.UnitPrice,scope.row)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "scope.row.FirstChargeUnitId",
                    label: "计价单位",
                    width: "100px",
                    "show-overflow-tooltip": true
                  }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("div", _hoisted_14, [
                        (scope.row.FirstChargeUnit!=undefined)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.isString(scope.row.FirstChargeUnit.FullName,scope.row)), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_16, "暂无数据"))
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "scope.row.FirstChargeUnitNumber",
                    label: "数量",
                    width: "100px",
                    "show-overflow-tooltip": true
                  }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.isString(scope.row.FirstChargeUnitNumber,scope.row)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "scope.row.TotalPrice",
                    label: "单项合计",
                    width: "120px",
                    "show-overflow-tooltip": true
                  }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.isString(scope.row.TotalPrice,scope.row)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "scope.row.Remark",
                    label: "备注",
                    "show-overflow-tooltip": true
                  }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.isString(scope.row.Remark,scope.row)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "scope.row.TotalPrice",
                    label: "记账起始时间",
                    width: "140px",
                    "show-overflow-tooltip": true
                  }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.isString(scope.row.StartDateString,scope.row)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "scope.row.TotalPrice",
                    label: "账期（天数）",
                    width: "130px",
                    "show-overflow-tooltip": true
                  }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.isString(scope.row.AccountPeriod,scope.row)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "scope.row.InvoiceNumber",
                    label: "发票号码",
                    "show-overflow-tooltip": true
                  }, {
                    default: _withCtx((scope) => [
                      (scope.row.InvoiceNumber!=null && scope.row.InvoiceNumber!=undefined && scope.row.InvoiceNumber !='' && scope.row.InvoiceNumber !='暂无数据')
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            onClick: ($event: any) => (_ctx.onInvoice(scope.row)),
                            style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap","color":"#fe995b"}
                          }, _toDisplayString(_ctx.isString(scope.row.InvoiceNumber,scope.row)), 9, _hoisted_22))
                        : (_openBlock(), _createElementBlock("div", _hoisted_23, " 暂无数据 "))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "scope.row.SettlementTypeString",
                    label: "核销状态",
                    "show-overflow-tooltip": true
                  }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("div", {
                        onClick: ($event: any) => (_ctx.onSettlement(scope.row)),
                        style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap","color":"#fe995b"}
                      }, _toDisplayString(_ctx.isString(scope.row.SettlementTypeString,scope.row)), 9, _hoisted_24)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["row-class-name", "data"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (_ctx.invoiceForm != undefined)
        ? (_openBlock(), _createBlock(_component_el_dialog, {
            key: 0,
            modelValue: _ctx.invoiceForm.Visiable,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.invoiceForm.Visiable) = $event)),
            "show-close": false,
            style: {"width":"70%"},
            top: "10px",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "append-to-body": true
          }, {
            header: _withCtx(({ close }) => [
              _hoisted_25,
              _createElementVNode("div", _hoisted_26, [
                _createVNode(_component_el_icon, {
                  style: {"cursor":"pointer"},
                  onClick: close
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CloseBold)
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_component_el_form, {
                  ref: "refInvoiceForm",
                  model: _ctx.invoiceForm,
                  rules: _ctx.rules
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      "label-width": "100px",
                      style: {"margin":"0px","padding":"0px"},
                      label: "账单合计"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.invoiceForm.BillString), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      "label-width": "100px",
                      style: {"margin":"0px","padding":"0px"},
                      label: "发票合计"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.invoiceForm.InvoiceString), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      "label-width": "100px",
                      label: "发票状态"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.invoiceForm.Status==30)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_27, "已添加"))
                          : (_ctx.invoiceForm.Status==20)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_28, "部分添加"))
                            : (_openBlock(), _createElementBlock("span", _hoisted_29, "待添加"))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table, {
                      ref: "invoiceTable",
                      border: "",
                      script: "",
                      data: _ctx.invoiceForm.InvoiceItems
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          prop: "Number",
                          label: "发票号码"
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("div", {
                              title: scope.row.Number,
                              style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
                            }, _toDisplayString(scope.row.Number), 9, _hoisted_30)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "CollectionTitle",
                          label: "收款方发票抬头"
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("div", {
                              title: scope.row.CollectionTitle,
                              style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
                            }, _toDisplayString(scope.row.CollectionTitle), 9, _hoisted_31)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "PaymentTitle",
                          label: "付款方发票抬头"
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("div", {
                              title: scope.row.PaymentTitle,
                              style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
                            }, _toDisplayString(scope.row.PaymentTitle), 9, _hoisted_32)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "CurrencySystemId",
                          width: "60",
                          label: "币制"
                        }, {
                          default: _withCtx((scope) => [
                            (scope.row.CurrencySystem!=null)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  title: scope.row.CurrencySystem.Code,
                                  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
                                }, _toDisplayString(scope.row.CurrencySystem.Code), 9, _hoisted_33))
                              : (_openBlock(), _createElementBlock("div", _hoisted_34, " 暂无数据 "))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "Price",
                          width: "140",
                          label: "金额"
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("div", {
                              title: scope.row.Price,
                              style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
                            }, _toDisplayString(scope.row.Price), 9, _hoisted_35)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "InvoiceDate",
                          width: "140",
                          label: "开票日期"
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("div", {
                              title: scope.row.InvoiceDateString,
                              style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
                            }, _toDisplayString(scope.row.InvoiceDateString), 9, _hoisted_36)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "Annexs",
                          width: "70",
                          label: "凭证"
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_37, [
                              _createVNode(_component_el_form_item, {
                                "label-width": "0px",
                                label: ""
                              }, {
                                default: _withCtx(() => [
                                  (scope.row.Annexs!=null && scope.row.Annexs!=undefined && scope.row.Annexs.length>0)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_38, [
                                        _createElementVNode("span", {
                                          onClick: ($event: any) => (_ctx.onAnnex(scope.row.Annexs[0])),
                                          style: {"cursor":"pointer","font-size":"18px"}
                                        }, [
                                          _createVNode(_component_el_icon, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_Document)
                                            ]),
                                            _: 1
                                          })
                                        ], 8, _hoisted_39)
                                      ]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_40, " 暂无数据 "))
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "Remark",
                          label: "备注"
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("div", {
                              title: scope.row.Remark,
                              style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
                            }, _toDisplayString(scope.row.Remark), 9, _hoisted_41)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["data"])
                  ]),
                  _: 1
                }, 8, ["model", "rules"])
              ]),
              _hoisted_42,
              _createElementVNode("div", _hoisted_43, [
                _createVNode(_component_miezz_button_bar, {
                  modelValue: _ctx.invoiceBottomButtons,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.invoiceBottomButtons) = $event)),
                  isBackground: true,
                  onHandleClick: _ctx.handleClickInvoice
                }, null, 8, ["modelValue", "onHandleClick"])
              ])
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (_ctx.settlementForm != undefined)
        ? (_openBlock(), _createBlock(_component_el_dialog, {
            key: 1,
            modelValue: _ctx.settlementForm.Visiable,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.settlementForm.Visiable) = $event)),
            "show-close": false,
            style: {"width":"90%"},
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            top: "0px",
            "append-to-body": true
          }, {
            header: _withCtx(({ close }) => [
              _hoisted_44,
              _createElementVNode("div", _hoisted_45, [
                _createVNode(_component_el_icon, {
                  style: {"cursor":"pointer"},
                  onClick: close
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CloseBold)
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_46, [
                _createVNode(_component_el_card, { style: {"margin-top":"5px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form, {
                      ref: "refSettlementForm",
                      model: _ctx.settlementForm,
                      rules: _ctx.settlementRules
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "总金额",
                          style: {"margin-top":"0px"},
                          "label-width": "100px"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.settlementForm.CurrencySystemCode) + _toDisplayString(_ctx.settlementForm.Total), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "待核销",
                          style: {"margin-top":"-10px"},
                          "label-width": "100px"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.settlementForm.CurrencySystemCode) + _toDisplayString(_ctx.settlementForm.NoSettlementPrice), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "已核销",
                          style: {"margin-top":"-10px"},
                          "label-width": "100px"
                        }, {
                          default: _withCtx(() => [
                            (_ctx.settlementForm.SettlementPrice!=null && _ctx.settlementForm.SettlementPrice!=undefined && _ctx.settlementForm.SettlementPrice!='')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(_ctx.settlementForm.SettlementPrice), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_48, "CNY0")),
                            (_ctx.settlementForm.NoSettlementPrice != 0 && _ctx.FinancialManagement_BillSummary_Writeoff==true)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_49, [
                                  _createElementVNode("span", {
                                    style: {"cursor":"pointer"},
                                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onAddSettlement && _ctx.onAddSettlement(...args)))
                                  }, [
                                    _createVNode(_component_el_icon, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Plus)
                                      ]),
                                      _: 1
                                    }),
                                    _createTextVNode(" 添加")
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        (_openBlock(), _createBlock(_component_el_table, {
                          ref: "settlementTable",
                          key: _ctx.settlementTableRandom,
                          data: _ctx.settlementForm.Items
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_table_column, {
                              prop: "Price",
                              "show-overflow-tooltip": true,
                              label: "核销金额"
                            }, {
                              default: _withCtx((scope) => [
                                _createElementVNode("div", _hoisted_50, _toDisplayString(scope.row.CurrencySystem.Code) + _toDisplayString(scope.row.Price), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "DisplayRate",
                              width: "90px",
                              "show-overflow-tooltip": true,
                              label: "汇率"
                            }, {
                              default: _withCtx((scope) => [
                                (scope.row.DisplayRate!=null && scope.row.DisplayRate!=undefined && scope.row.DisplayRate!='')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_51, _toDisplayString(scope.row.DisplayRate), 1))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_52, " 1 "))
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "SettlementDateString",
                              "show-overflow-tooltip": true,
                              label: "核销时间"
                            }, {
                              default: _withCtx((scope) => [
                                _createElementVNode("div", {
                                  title: scope.row.SettlementDateString,
                                  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
                                }, _toDisplayString(scope.row.SettlementDateString), 9, _hoisted_53)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "CollectionTitle",
                              "show-overflow-tooltip": true,
                              label: "收款方"
                            }, {
                              default: _withCtx((scope) => [
                                _createElementVNode("div", {
                                  title: scope.row.CollectionTitle,
                                  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
                                }, _toDisplayString(scope.row.CollectionTitle), 9, _hoisted_54)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "PaymentTitle",
                              "show-overflow-tooltip": true,
                              label: "付款方"
                            }, {
                              default: _withCtx((scope) => [
                                _createElementVNode("div", {
                                  title: scope.row.PaymentTitle,
                                  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
                                }, _toDisplayString(scope.row.PaymentTitle), 9, _hoisted_55)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "Mode",
                              "show-overflow-tooltip": true,
                              label: "核销方式"
                            }, {
                              default: _withCtx((scope) => [
                                _createElementVNode("div", _hoisted_56, [
                                  (scope.row.Mode == 10)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_57, "对公银行"))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_58, "现金/私人银行/其他"))
                                ])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "Remark",
                              "show-overflow-tooltip": true,
                              label: "备注"
                            }, {
                              default: _withCtx((scope) => [
                                _createElementVNode("div", {
                                  title: scope.row.Remark,
                                  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
                                }, _toDisplayString(scope.row.Remark), 9, _hoisted_59)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "CreatedUserName",
                              "show-overflow-tooltip": true,
                              label: "创建人"
                            }, {
                              default: _withCtx((scope) => [
                                _createElementVNode("div", {
                                  title: scope.row.CreatedUserName,
                                  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
                                }, _toDisplayString(scope.row.CreatedUserName), 9, _hoisted_60)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["data"]))
                      ]),
                      _: 1
                    }, 8, ["model", "rules"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_card, { style: {"margin-top":"5px","display":"none"} }, {
                  header: _withCtx(() => [
                    _createElementVNode("div", {
                      style: {"width":"100% !important","cursor":"pointer","height":"50px","line-height":"50px"},
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isHistory = !_ctx.isHistory))
                    }, [
                      _hoisted_61,
                      _createElementVNode("div", _hoisted_62, [
                        (_ctx.isHistory==false)
                          ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ArrowDownBold)
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(_component_el_icon, { key: 1 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ArrowUpBold)
                              ]),
                              _: 1
                            }))
                      ])
                    ]),
                    (_ctx.isHistory==false)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                          (_ctx.historys.Data.Items!=null && _ctx.historys.Data.Items != undefined && _ctx.historys.Data.Items.length>0)
                            ? (_openBlock(), _createBlock(_component_el_timeline, { key: 0 }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.historys.Data.Items, (activity, index) => {
                                    return (_openBlock(), _createBlock(_component_el_timeline_item, {
                                      key: index,
                                      timestamp: activity.CreatedTime,
                                      "hide-timestamp": true
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_64, [
                                          _createElementVNode("div", {
                                            style: {"cursor":"pointer"},
                                            onClick: ($event: any) => (activity.IsOpen = !activity.IsOpen)
                                          }, [
                                            _createElementVNode("div", _hoisted_66, [
                                              _createTextVNode(_toDisplayString(activity.CreatedTime) + " 由", 1),
                                              _createElementVNode("span", _hoisted_67, _toDisplayString(activity.CreatedUserName) + "（" + _toDisplayString(activity.CreatedCompanyNameZh) + "）", 1),
                                              _createTextVNode(_toDisplayString(activity.Title), 1),
                                              (activity.NewLabel!=null && activity.NewLabel!=undefined && activity.NewLabel!='')
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_68, "（" + _toDisplayString(activity.NewLabel) + "）", 1))
                                                : _createCommentVNode("", true)
                                            ]),
                                            (activity.IsOpen==false && activity.Child!=null && activity.Child!=undefined && activity.Child.length>0)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                                                  _createVNode(_component_el_icon, null, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_Plus)
                                                    ]),
                                                    _: 1
                                                  })
                                                ]))
                                              : _createCommentVNode("", true),
                                            (activity.IsOpen==true && activity.Child!=null && activity.Child!=undefined && activity.Child.length>0)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                                                  _createVNode(_component_el_icon, null, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_Minus)
                                                    ]),
                                                    _: 1
                                                  })
                                                ]))
                                              : _createCommentVNode("", true),
                                            _hoisted_71
                                          ], 8, _hoisted_65),
                                          (activity.Child!=null && activity.Child!=undefined && activity.Child.length>0 && activity.IsOpen==true)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activity.Child, (p, index1) => {
                                                  return (_openBlock(), _createElementBlock("div", { key: index1 }, [
                                                    (p.Title!=null && p.Title!=undefined && p.Title!='')
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                                                          (p.Child!=null && p.Child!=undefined && p.Child.length>0)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_74, _toDisplayString(p.Title), 1))
                                                            : _createCommentVNode("", true),
                                                          (p.Child!=null && p.Child!=undefined && p.Child.length>0)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                                                                (p.Child!=null && p.Child!=undefined && p.Child.length>0)
                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p.Child, (p2, index2) => {
                                                                        return (_openBlock(), _createElementBlock("div", { key: index2 }, [
                                                                          (p2.Child==null || p2.Child==undefined || p2.Child.length<=0)
                                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                                                                                (p2.State==4 && (index2==0 || p.IsOpen==true))
                                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                                                                                      _createTextVNode("新增了"),
                                                                                      _createElementVNode("span", _hoisted_79, _toDisplayString(p2.Label), 1),
                                                                                      _createTextVNode("，新值为\"" + _toDisplayString(p2.NewLabel) + "\"", 1)
                                                                                    ]))
                                                                                  : _createCommentVNode("", true),
                                                                                (p2.State==3 && (index2==0 || p.IsOpen==true))
                                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                                                                                      _createTextVNode("编辑了"),
                                                                                      _createElementVNode("span", _hoisted_81, _toDisplayString(p2.Label), 1),
                                                                                      _createTextVNode("，由\"" + _toDisplayString(p2.OldLabel) + "\"改为\"" + _toDisplayString(p2.NewLabel) + "\"", 1)
                                                                                    ]))
                                                                                  : _createCommentVNode("", true),
                                                                                (p2.State==2 && (index2==0 || p.IsOpen==true))
                                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                                                                      _createTextVNode("删除了"),
                                                                                      _createElementVNode("span", _hoisted_83, _toDisplayString(p2.Label), 1),
                                                                                      _createTextVNode("，原值为\"" + _toDisplayString(p2.NewLabel) + "\"", 1)
                                                                                    ]))
                                                                                  : _createCommentVNode("", true),
                                                                                (p2.State==999 && (index2==0 || p.IsOpen==true))
                                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                                                                                      _createElementVNode("span", _hoisted_85, "未编辑" + _toDisplayString(p2.Label), 1),
                                                                                      _createTextVNode("，原值为\"" + _toDisplayString(p2.OldLabel) + "\"", 1)
                                                                                    ]))
                                                                                  : _createCommentVNode("", true),
                                                                                (p.IsOpen==false && index2==0)
                                                                                  ? (_openBlock(), _createElementBlock("div", {
                                                                                      key: 4,
                                                                                      onClick: ($event: any) => (p.IsOpen = !p.IsOpen),
                                                                                      style: {"margin-top":"5px","margin-left":"5px","cursor":"pointer","font-size":"10px","border":"1px solid #aaa","height":"16px","width":"16px","float":"left","text-align":"center","line-height":"16px"}
                                                                                    }, [
                                                                                      _createVNode(_component_el_icon, null, {
                                                                                        default: _withCtx(() => [
                                                                                          _createVNode(_component_Plus)
                                                                                        ]),
                                                                                        _: 1
                                                                                      })
                                                                                    ], 8, _hoisted_86))
                                                                                  : _createCommentVNode("", true),
                                                                                (p.IsOpen==true && index2==0)
                                                                                  ? (_openBlock(), _createElementBlock("div", {
                                                                                      key: 5,
                                                                                      onClick: ($event: any) => (p.IsOpen = !p.IsOpen),
                                                                                      style: {"margin-top":"5px","margin-left":"5px","cursor":"pointer","font-size":"10px","border":"1px solid #aaa","height":"16px","width":"16px","float":"left","text-align":"center","line-height":"16px"}
                                                                                    }, [
                                                                                      _createVNode(_component_el_icon, null, {
                                                                                        default: _withCtx(() => [
                                                                                          _createVNode(_component_Minus)
                                                                                        ]),
                                                                                        _: 1
                                                                                      })
                                                                                    ], 8, _hoisted_87))
                                                                                  : _createCommentVNode("", true),
                                                                                _hoisted_88
                                                                              ]))
                                                                            : (_openBlock(), _createElementBlock("div", _hoisted_89, [
                                                                                (p2.Title!=null && p2.Title!=undefined && p2.Title!='')
                                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_90, _toDisplayString(p2.Title), 1))
                                                                                  : (_openBlock(), _createElementBlock("div", _hoisted_91, _toDisplayString(p2.NewLabel), 1))
                                                                              ])),
                                                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p2.Child, (p3, index3) => {
                                                                            return (_openBlock(), _createElementBlock("div", {
                                                                              key: index3,
                                                                              style: {"line-height":"28px"}
                                                                            }, [
                                                                              (p3.State==4 && (index3==0 || p2.IsOpen==true))
                                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                                                                                    _createTextVNode("新增了"),
                                                                                    _createElementVNode("span", _hoisted_93, _toDisplayString(p3.Label), 1),
                                                                                    _createTextVNode("，新值为\"" + _toDisplayString(p3.NewLabel) + "\"", 1)
                                                                                  ]))
                                                                                : _createCommentVNode("", true),
                                                                              (p3.State==3 && (index3==0 || p2.IsOpen==true))
                                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                                                                                    _createTextVNode("编辑了"),
                                                                                    _createElementVNode("span", _hoisted_95, _toDisplayString(p3.Label), 1),
                                                                                    _createTextVNode("，由\"" + _toDisplayString(p3.OldLabel) + "\"改为\"" + _toDisplayString(p3.NewLabel) + "\"", 1)
                                                                                  ]))
                                                                                : _createCommentVNode("", true),
                                                                              (p3.State==2 && (index3==0 || p2.IsOpen==true))
                                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                                                                                    _createTextVNode("删除了"),
                                                                                    _createElementVNode("span", _hoisted_97, _toDisplayString(p3.Label), 1),
                                                                                    _createTextVNode("，原值为\"" + _toDisplayString(p3.NewLabel) + "\"", 1)
                                                                                  ]))
                                                                                : _createCommentVNode("", true),
                                                                              (p3.State==999 && (index3==0 || p2.IsOpen==true))
                                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                                                                                    _createElementVNode("span", _hoisted_99, "未编辑" + _toDisplayString(p3.Label), 1),
                                                                                    _createTextVNode("，原值为\"" + _toDisplayString(p3.OldLabel) + "\"", 1)
                                                                                  ]))
                                                                                : _createCommentVNode("", true),
                                                                              (p2.IsOpen==false && index3==0)
                                                                                ? (_openBlock(), _createElementBlock("div", {
                                                                                    key: 4,
                                                                                    onClick: ($event: any) => (p2.IsOpen = !p2.IsOpen),
                                                                                    style: {"margin-top":"5px","margin-left":"5px","cursor":"pointer","font-size":"10px","border":"1px solid #aaa","height":"16px","width":"16px","float":"left","text-align":"center","line-height":"16px"}
                                                                                  }, [
                                                                                    _createVNode(_component_el_icon, null, {
                                                                                      default: _withCtx(() => [
                                                                                        _createVNode(_component_Plus)
                                                                                      ]),
                                                                                      _: 1
                                                                                    })
                                                                                  ], 8, _hoisted_100))
                                                                                : _createCommentVNode("", true),
                                                                              (p2.IsOpen==true && index3==0)
                                                                                ? (_openBlock(), _createElementBlock("div", {
                                                                                    key: 5,
                                                                                    onClick: ($event: any) => (p2.IsOpen = !p2.IsOpen),
                                                                                    style: {"margin-top":"5px","margin-left":"5px","cursor":"pointer","font-size":"10px","border":"1px solid #aaa","height":"16px","width":"16px","float":"left","text-align":"center","line-height":"16px"}
                                                                                  }, [
                                                                                    _createVNode(_component_el_icon, null, {
                                                                                      default: _withCtx(() => [
                                                                                        _createVNode(_component_Minus)
                                                                                      ]),
                                                                                      _: 1
                                                                                    })
                                                                                  ], 8, _hoisted_101))
                                                                                : _createCommentVNode("", true),
                                                                              _hoisted_102
                                                                            ]))
                                                                          }), 128))
                                                                        ]))
                                                                      }), 128))
                                                                    ]))
                                                                  : (_openBlock(), _createElementBlock("div", _hoisted_103, "—"))
                                                              ]))
                                                            : _createCommentVNode("", true),
                                                          _hoisted_104
                                                        ]))
                                                      : (_openBlock(), _createElementBlock("div", _hoisted_105, [
                                                          (p.Child==null || p.Child==undefined || p.Child.length<=0)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
                                                                (p.State==4)
                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
                                                                      _createTextVNode("新增了"),
                                                                      _createElementVNode("span", _hoisted_108, _toDisplayString(p.Label), 1),
                                                                      _createTextVNode("，新值为\"" + _toDisplayString(p.NewLabel) + "\"", 1)
                                                                    ]))
                                                                  : _createCommentVNode("", true),
                                                                (p.State==3)
                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
                                                                      _createTextVNode("编辑了"),
                                                                      _createElementVNode("span", _hoisted_110, _toDisplayString(p.Label), 1),
                                                                      _createTextVNode("，由\"" + _toDisplayString(p.OldLabel) + "\"改为\"" + _toDisplayString(p.NewLabel) + "\"", 1)
                                                                    ]))
                                                                  : _createCommentVNode("", true),
                                                                (p.State==2)
                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
                                                                      _createTextVNode("删除了"),
                                                                      _createElementVNode("span", _hoisted_112, _toDisplayString(p.Label), 1),
                                                                      _createTextVNode("，原值为\"" + _toDisplayString(p.NewLabel) + "\"", 1)
                                                                    ]))
                                                                  : _createCommentVNode("", true),
                                                                (p.State==999)
                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                                                                      _createElementVNode("span", _hoisted_114, "未编辑" + _toDisplayString(p.Label), 1),
                                                                      _createTextVNode("，原值为\"" + _toDisplayString(p.OldLabel) + "\"", 1)
                                                                    ]))
                                                                  : _createCommentVNode("", true)
                                                              ]))
                                                            : (_openBlock(), _createElementBlock("div", _hoisted_115, [
                                                                (p.Title!=null && p.Title!=undefined && p.Title!='')
                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_116, _toDisplayString(p.Title), 1))
                                                                  : (_openBlock(), _createElementBlock("div", _hoisted_117, _toDisplayString(p.NewLabel), 1)),
                                                                _createElementVNode("div", _hoisted_118, [
                                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p.Child, (p3, index3) => {
                                                                    return (_openBlock(), _createElementBlock("div", {
                                                                      style: {"clear":"both"},
                                                                      key: index3
                                                                    }, [
                                                                      (p3.State==4)
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_119, [
                                                                            _createTextVNode("新增了"),
                                                                            _createElementVNode("span", _hoisted_120, _toDisplayString(p3.Label), 1),
                                                                            _createTextVNode("，新值为\"" + _toDisplayString(p3.NewLabel) + "\"", 1)
                                                                          ]))
                                                                        : _createCommentVNode("", true),
                                                                      (p3.State==3)
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_121, [
                                                                            _createTextVNode("编辑了"),
                                                                            _createElementVNode("span", _hoisted_122, _toDisplayString(p3.Label), 1),
                                                                            _createTextVNode("，由\"" + _toDisplayString(p3.OldLabel) + "\"改为\"" + _toDisplayString(p3.NewLabel) + "\"", 1)
                                                                          ]))
                                                                        : _createCommentVNode("", true),
                                                                      (p3.State==2)
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_123, [
                                                                            _createTextVNode("删除了"),
                                                                            _createElementVNode("span", _hoisted_124, _toDisplayString(p3.Label), 1),
                                                                            _createTextVNode("，原值为\"" + _toDisplayString(p3.NewLabel) + "\"", 1)
                                                                          ]))
                                                                        : _createCommentVNode("", true),
                                                                      (p3.State==999)
                                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_125, [
                                                                            _createElementVNode("span", _hoisted_126, "未编辑" + _toDisplayString(p3.Label), 1),
                                                                            _createTextVNode("，原值为\"" + _toDisplayString(p3.OldLabel) + "\"", 1)
                                                                          ]))
                                                                        : _createCommentVNode("", true)
                                                                    ]))
                                                                  }), 128)),
                                                                  _hoisted_127
                                                                ]),
                                                                _hoisted_128
                                                              ]))
                                                        ]))
                                                  ]))
                                                }), 128))
                                              ]))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]),
                                      _: 2
                                    }, 1032, ["timestamp"]))
                                  }), 128))
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createElementBlock("div", _hoisted_129, " 暂无数据 "))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _hoisted_130,
              _createElementVNode("div", _hoisted_131, [
                _createVNode(_component_miezz_button_bar, {
                  modelValue: _ctx.settlementBottomButtons,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.settlementBottomButtons) = $event)),
                  isBackground: true,
                  onHandleClick: _ctx.handleClickSettlement
                }, null, 8, ["modelValue", "onHandleClick"])
              ])
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true)
    ])), [
      [
        _directive_loading,
        _ctx.isLoading,
        void 0,
        {
          fullscreen: true,
          lock: true
        }
      ]
    ]),
    _createVNode(_component_miezz_button_bar, {
      modelValue: _ctx.bottomButtons,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.bottomButtons) = $event)),
      onHandleClick: _ctx.handleClick
    }, null, 8, ["modelValue", "onHandleClick"])
  ], 64))
}